export default __webpack_public_path__ + "static/media/goodanswer.18e9cd75.ogg";